import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import type { ClusterListResponseOutputProgress } from '@/api/generated';
import { CompletionIndicator } from '@/components/ui/completion-indicator';
import { cn } from '@/lib/utils';

export const ClusterProgress: FC<{
  progress: ClusterListResponseOutputProgress;
  categories: Array<string>;
  className?: string;
}> = ({ progress, categories, className }) => {
  const { t } = useTranslation();
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <span className='text-sm'>
        <span className='text-muted-foreground'>
          {categories.length
            ? categories.join(', ')
            : t('clusters.allCategoriesScope')}
          {' · '}
        </span>
        <Trans
          i18nKey='clusters.progress'
          values={{
            done: progress.done,
            clusters: progress.clusters,
            left: progress.clusters - progress.done,
            photos: progress.waitingPhotos,
          }}
          components={{ bold: <b /> }}
        />
      </span>
      <div
        role='progressbar'
        aria-label={t('clusters.progressLabel')}
        aria-valuemin={0}
        aria-valuemax={progress.clusters}
        aria-valuenow={progress.done}>
        <CompletionIndicator
          className='h-3'
          rate={
            progress.clusters ? (100 * progress.done) / progress.clusters : 0
          }
        />
      </div>
    </div>
  );
};
